import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const paper = css`
  :last-child {
    border-end-end-radius: 0;
    border-end-start-radius: 0;
    block-size: 100%;
  }
  block-size: auto;
  margin-block-end: ${spacing(1)};
`

export const container = css`
  height: 100%;
`

export const popper = css`
  inline-size: calc(100vw - ${spacing(6)});
  overflow: scroll;
  max-block-size: ${spacing(33)};
  box-shadow: ${cssTheme.shadows.bottomNormal};
`

export const itemsPaper = css`
  min-height: 100%;

  :last-child {
    border-end-end-radius: 0;
    border-end-start-radius: 0;
    width: 100%;
    height: auto;
  }
  block-size: auto;
  margin-block-end: ${spacing(1)};
`

export const input = css`
  &:before {
    content: none;
  }
`

export const inputContainer = css`
  inline-size: 100%;
`
